import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const Prompt = makeShortcode("Prompt");
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`When you have two-factor access enabled on your account, and you lose access to your 2FA device, you may be able to recover your account using the following methods.`}</p>
    <h2>{`Misplaced second factor device`}</h2>
    <p>{`If you have misplaced the device that provided second-factor authentication, you can use the recovery codes generated when you `}<a parentName="p" {...{
        "href": "/configuring-two-factor-authentication#enabling-2fa-on-the-web"
      }}>{`enabled 2FA`}</a>{` to access your account.`}</p>
    <h3>{`Using recovery code on the web`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Locate the recovery codes generated that you have saved.`}</p>
      </li>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on "Use recovery code" from the next screen`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/recovery-code-link.png" alt="Screenshot showing Security Key prompt with a link to navigate to the recovery code input screen" mdxType="Screenshot" />
        <p parentName="li"><em parentName="p">{`Note: If you have configured to use TOTP, you will see an TOTP prompt instead`}</em></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enter an unused recovery code in the "Use a Recovery Code" prompt`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/user-a-recovery-code.png" alt="Screenshot showing use a recovery code prompt with an input box to enter the recovery code" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`You are now logged into npm.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Follow the steps mentioned in "`}<a parentName="p" {...{
            "href": "/configuring-two-factor-authentication#removing-2fa-on-the-web"
          }}>{`Removing 2FA on the web`}</a>{`" to disable 2FA`}</p>
      </li>
    </ol>
    <h3>{`Using recovery code from the command line`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Locate the recovery codes generated when you enabled 2FA on your account.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you are logged out on the command line, log in using `}<inlineCode parentName="p">{`npm login`}</inlineCode>{` command with your username and npm password.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enter an unused recovery code when you see this prompt:`}</p>
        <Prompt mdxType="Prompt">Enter one-time password:</Prompt>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Once you are logged in, use the below and enter your npm password if prompted.  `}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm profile disable-2fa
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enter another unused recovery code when you see this prompt:`}</p>
        <Prompt mdxType="Prompt">Enter one-time password:</Prompt>
      </li>
      <li parentName="ol">
        <p parentName="li">{`npm will confirm that two-factor authentication has been disabled.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Follow the steps outlined in "`}<a parentName="p" {...{
            "href": "/configuring-two-factor-authentication"
          }}>{`Configuring two-factor authentication`}</a>{`" to re-enable 2FA and generate new recovery codes.`}</p>
      </li>
    </ol>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Using the recovery codes to re-enable 2FA may create a new authenticator account with the same npm account name.`}</p>
      <p>{`If you are using a `}<a parentName="p" {...{
          "href": "https://en.wikipedia.org/wiki/Time-based_one-time_password"
        }}>{`time-based one-time password (TOTP)`}</a>{` mobile app and want to delete the old authenticator account, follow the steps for the authenticator.`}</p>
    </Note>
    <h2>{`Viewing and regenerating recovery code`}</h2>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{`  Once you regenerate a set of code, all previous recovery codes become invalid. Each code can be used only once.`}</p>
    </Note>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the account settings page, under "Two-Factor Authentication", click `}<strong parentName="p">{`Modify 2FA`}</strong>{`.`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/2fa-modify.png" alt="Screenshot showing Modify 2FA button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click "Manage Recovery Codes'' to view your recovery codes`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/view-recovery-codes.png" alt="Screenshot showing existing recovery codes and a button to generate set of recovery codes" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click "Regenerate Code" to generate a new set of codes.`}</p>
      </li>
    </ol>
    <h2>{`Misplaced recovery codes`}</h2>
    <p>{`If you have misplaced both the device that provided second-factor authentication and your recovery codes, we may be unable to help you recover your account. If you have any questions, please `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/support"
      }}>{`contact npm Support`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      